

/**
 * @name AccountAlertsController
 * @description Controller for the account alerts component
 * @param {service} Session The session service
 * @param {constant} NOTIFICATIONS The NOTIFICATIONS constant
 * @param {service} Notification The Notification service
 * @param {service} Collector The Collector service
 */
function AccountAlertsController(
  Session,
  NOTIFICATIONS,
  Notification,
  Collector
) {
  let vm = this;

  vm.$onInit = function() {
    vm.session = Session;
    vm.verifyEmail = verifyEmail;

    // Refresh the collector if email_is_confirmed is false to check to see if its
    // now true.
    if (!vm.session.collector.email_is_confirmed) {
      Collector.refreshProfile();
    }
  };

  /**
   * @name verifyEmail
   * @description description
   * @param {type} collector The collector to verify email for
   */
  function verifyEmail(collector) {
    let confirmEmailNotification = {
      recipients: [collector.id],
      notificationId: NOTIFICATIONS.emailConfirmation,
      messageObjects: {
        collectorId: collector.id
      },
      messageVariables: {
        subject: 'Action required: please verify your email address'
      }
    };
    Notification.send(confirmEmailNotification);
  }
}

angular
  .module('inkfinder')
  .controller('AccountAlertsController', AccountAlertsController);



// WEBPACK FOOTER //
// ./components/collector/account-alerts/account-alerts.controller.js